import { Module } from 'vuex';
import stripeState, { StripeState } from './state';
import { RootState } from '../../state';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

const stripe: Module<StripeState, RootState> = {
  namespaced: true,
  state: stripeState,
  actions,
  mutations,
  getters
};

export default stripe;
